

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { EyeIcon, ArrowPathIcon } from "@heroicons/react/24/outline";
import { getOrdersByCustomerId } from "../../features/admin/OrderSlice";
import TableComponent from "../../components/TableComponent";
import { toast } from "react-toastify";
import OrderModal from "../../components/admin/OrderModal";
import { formatCurrencyVND } from "../../utils/helps";
import AuditHistoryButton from "../../components/admin/AuditHistoryButton";

const OrdersHistory = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [orders, setOrders] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const handleOpenModal = (item = null) => {
    setCurrentOrder(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentOrder(null);
  };

  const userId = localStorage.getItem("userId");
  useEffect(() => {
    getCompanyInfo();
  }, []);

  const getCompanyInfo = async () => {
    const data = await dispatch(getOrdersByCustomerId(userId)).unwrap();
    setOrders(data);
  };

  const headers = [
    {
      key: "id",
      label: "Mã giao dịch",
    },
    {
      label: "Giao dịch",
      render: (item) => (
        <div className="flex gap-4 items-center">
          <div className="w-12 h-12 rounded-full overflow-hidden">
            {item?.details[0]?.product?.urlImage ? (
              <div className="flex w-full h-full gap-4">
                <img
                  src={item?.details[0]?.product?.urlImage[0]}
                  alt={item?.companyName}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            ) : (
              <div className="w-full h-full bg-gray-200 flex items-center justify-center text-gray-400">
                No img
              </div>
            )}
          </div>
          <p className="font-medium text-b">
            {" "}
            Sản phẩm: x {item.details.length}
          </p>
          <p className="font-medium text-b">
            {" "}
            Tổng tiền: {formatCurrencyVND(item.totalPrice)}
          </p>
        </div>
      ),
    },
    {
      key: "status",
      label: "Trạng thái",
      render: (item) => (
        <span
          className={`px-3 py-1 rounded-full text-sm ${
            item.status === "success"
              ? "bg-green-100 text-green-800"
              : item.status === "pending"
              ? "bg-yellow-100 text-yellow-800"
              : "bg-red-100 text-red-800"
          } whitespace-nowrap`}
        >
          {item.status === "pending"
            ? "Chờ xác nhận"
            : item.status === "success"
            ? "Đã xác nhận"
            : "Đã huỷ"}
        </span>
      ),
    },
    { key: "setting", label: "Thao tác" },
  ];

  const tableSettings = {
    renderSettings: (item) => (
      <div className="flex space-x-2">
        <button
          onClick={() => handleOpenModal(item)}
          title="Xem chi tiết"
          className="btn btn-outline btn-info btn-sm px-3 my-1 rounded"
        >
          <EyeIcon className="w-5 h-5" />
        </button>
        <AuditHistoryButton module="ORDER" entityType="Order" entityId={item.id} />
      </div>
    ),
  };

  const filterData = orders.filter((item) =>
    searchValue === ""
      ? true
      : [...item.details.map((detail) => detail.product.name)].some((field) =>
          field?.toLowerCase().includes(searchValue.toLowerCase())
        )
  );

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold ">Lịch sử giao dịch</h1>
        <div className=" flex items-center space-x-2">
          <label
            htmlFor="userSearchFilter"
            className="text-sm font-medium w-24"
          >
            Tìm kiếm:
          </label>
          <input
            type="search"
            className="w-full px-2 py-1 border rounded-lg focus:outline-none pr-10"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
      </div>
      <div className="rounded-lg shadow">
        <TableComponent
          headers={headers}
          data={filterData}
          settings={tableSettings}
        />
      </div>

      {isModalOpen && (
        <OrderModal
          orderId={currentOrder?.id || null}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default OrdersHistory;



